module.exports = __webpack_public_path__ + "img/profile_picture_old.e8a4fd21.jpg";